module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-21.f0cf17e7.png";